import React from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { Users, Store, Building2 } from 'lucide-react';
import { usePermissions } from '../contexts/PermissionsContext';

/**
 * Header de fusion « Équipe & Magasins » — URL canonique `/admin/equipe-magasins?tab=...`
 * Super-admin : Utilisateurs · Magasins · Clients B2B
 * Admin magasin : Clients B2B uniquement
 */
const ALL_TABS = [
  { key: 'users', label: 'Utilisateurs', icon: Users, search: '', superOnly: true },
  { key: 'magasins', label: 'Magasins', icon: Store, search: '?tab=magasins', superOnly: true },
  { key: 'b2b', label: 'Clients B2B', icon: Building2, search: '?tab=b2b', superOnly: false },
];

const AdminEquipeMagasinsTabs = ({ active }) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { isSuper } = usePermissions();

  const tabParam = (searchParams.get('tab') || '').toLowerCase();
  const fromPath = location.pathname.includes('/magasins') ? 'magasins' : 'users';
  const current = active || tabParam || (isSuper ? fromPath : 'b2b');

  const tabs = ALL_TABS.filter((t) => isSuper || !t.superOnly);

  return (
    <div className="mb-4" data-testid="admin-equipe-tabs">
      <h2 className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-cyan-400 mb-3">
        Équipe &amp; Magasins
      </h2>
      <div className="flex items-center gap-2 border-b border-white/10 -mx-1 px-1 overflow-x-auto">
        {tabs.map((t) => {
          const Icon = t.icon;
          const isActive = current === t.key;
          return (
            <Link
              key={t.key}
              to={`/admin/equipe-magasins${t.search}`}
              className={`flex items-center gap-2 px-3 py-2 text-sm border-b-2 -mb-px transition-colors whitespace-nowrap ${
                isActive
                  ? 'border-emerald-400 text-emerald-200 font-bold'
                  : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-white/20'
              }`}
              data-testid={`admin-equipe-tab-${t.key}`}
            >
              <Icon className="w-4 h-4" />
              <span>{t.label}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default AdminEquipeMagasinsTabs;
